require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./lifestyle-health-wellness.json") })
        }
      }, "path---lifestyle-health-wellness");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---lifestyle-health-wellness!./.cache/json/lifestyle-health-wellness.json
// module id = 775
// module chunks = 231608221292675